




















import { defineComponent } from '@vue/composition-api';
export default defineComponent({
  name: 'ActionSheet',
  setup(props, context) {
    const methods = {
      onClose() {
        context.emit('onClose');
      },
    };
    return {
      ...methods,
    };
  },
});
